import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const longStartBadgeDefinition: BoggleBadgeDefinition = {
  category: 'speed',
  description: 'Play a word of length 8+ in the first 8 seconds',
  iconId: 'longStart',
  id: 'longStart',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Long Start',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
